import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["resize", "disabled", "invalid", "size", "height", "onChange", "onFocus", "onBlur"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useInputSize } from '@cian/ui-kit/internal/hooks';
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { getInputAdornmentStyles } from './getTextAreaStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export var TextArea = function TextArea(_ref) {
  var resize = _ref.resize,
    disabled = _ref.disabled,
    invalid = _ref.invalid,
    sizeProp = _ref.size,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'default' : _ref$height,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var size = useInputSize(sizeProp);
  var styles = getInputAdornmentStyles(size);
  var handleFocus = function handleFocus(e) {
    setFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleBlur = function handleBlur(e) {
    setFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e, e.currentTarget.value);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: cx(styles['textarea-wrapper'], focused && styles['focused'], disabled && styles['disabled'], invalid && styles['invalid'], height === 'min' && styles['height-min'], height === 'medium' && styles['height-medium'], resize === 'vertical' && styles['resize-vertical'], resize === 'horizontal' && styles['resize-horizontal'], resize === 'both' && styles['resize-both'], resize === 'none' && styles['resize-none']),
    children: /*#__PURE__*/_jsx("textarea", _objectSpread(_objectSpread({
      className: styles['textarea']
    }, rest), {}, {
      disabled: disabled,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur
    }))
  });
};